import { lazy } from "react";
import lazyLoad from "routers/utils/lazyLoad";
import LayoutIndex from "layout/mainLayout";

const myProfileRouter = [
  {
    element: <LayoutIndex />,
    children: [
      {
        path: "/myProfile",
        element: lazyLoad(lazy(() => import("view/myProfile"))),
      },
    ]
  },
];

export default myProfileRouter;
